// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"56b74d00","598":"9bdc7706"}[chunkId] + ".chunk.js";
};